/** iOS/iPadOS (iPad маскируется под Mac — отличаем по мультитачу). */
export function isIOS(): boolean {
  if (typeof navigator === "undefined") return false
  return (
    /iPhone|iPad|iPod/.test(navigator.userAgent) || (/Mac/.test(navigator.userAgent) && navigator.maxTouchPoints > 1)
  )
}
